const Routes_gral = {
    login: '/',
    home: '/Home',
    user: '/User',
    group: '/Group',
    product: '/Product',
    addReq: '/addReq',
    reqSector: '/reqSector',
    subcuentas: '/subcuentas',
    globalSettings: '/globalSettings',
    warehouse: '/warehouse',
    distribucion: '/distribucion',
}

export default Routes_gral